import { Time } from '../models/chart.model';

export const msToMinutesSeconds = (ms: number) => {
  const minutes = Math.floor(ms / 60000);
  const seconds = ((ms % 60000) / 1000).toFixed(0);

  return `${minutes}:${seconds.padStart(2, '0')}`;
};

// This function assumes that the minute part does not exceed 99 minutes
export const msToMinutesSecondsWithUnit = (ms: number): Time => {
  const minutes = Math.floor(ms / 1000 / 60);
  const seconds = (ms / 1000) % 60;
  const minutesString = minutes.toFixed(0).padStart(2, '0');
  const secondsString = seconds.toFixed(0).padStart(2, '0');

  if (!minutes && !seconds) {
    return { value: '00:00', unit: '' };
  }

  if (minutes < 1) {
    return { value: `00:${secondsString}`, unit: 'Second(s)' };
  }

  return { value: `${minutesString}:${secondsString}`, unit: 'Minute(s)' };
};
